(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cake-block-reviews"] && !Shopify.designMode) return;
  try {
    /* Reviews-specific behaviour only. The drawer shell (open/close/backdrop/ESC/focus/
     animation) is the shared bh-drawer component, driven by the native
     <dialog id="BhReviewsSheet"> + the trigger's aria-controls. Here we keep the
     show-more clamps and the photo lightbox (its own <dialog> for correct top-layer
     stacking above the drawer). */
  class BhReviewsDrawer extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('[data-open]');
      this.list = this.querySelector('.bh-reviews__list');
      this.lb = this.querySelector('[data-lightbox]');
      this.lbImg = this.querySelector('[data-lb-img]');
      this.lbCounter = this.querySelector('[data-lb-counter]');
      this.lbPrev = this.querySelector('[data-lb-prev]');
      this.lbNext = this.querySelector('[data-lb-next]');

      // Clamp detection needs the panel laid out — schedule it after the drawer opens.
      if (this.trigger) {
        this.trigger.addEventListener('click', () => {
          requestAnimationFrame(() => requestAnimationFrame(() => this._setupClamps()));
        });
      }

      // Delegate: show-more toggles + photo clicks
      if (this.list) {
        this.list.addEventListener('click', (e) => {
          var more = e.target.closest('[data-more]');
          if (more) { this._toggleMore(more); return; }
          var photo = e.target.closest('.bh-reviews__photo');
          if (photo) { this._openGalleryFrom(photo); }
        });
      }

      // Lightbox controls
      if (this.lb) {
        this.querySelector('[data-lb-close]').addEventListener('click', () => this.closeGallery());
        this.lbPrev.addEventListener('click', () => this.step(-1));
        this.lbNext.addEventListener('click', () => this.step(1));
        this._bindSwipe();
        this.lb.addEventListener('cancel', (e) => { e.preventDefault(); this.closeGallery(); }); // ESC → animate out
        this.lb.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.step(-1);
          else if (e.key === 'ArrowRight') this.step(1);
        });
      }
    }

    /* ---- Show more ---- */
    _setupClamps() {
      if (this._clampsDone) return;
      this._clampsDone = true;
      this.querySelectorAll('.bh-reviews__text').forEach((t) => {
        if (t.scrollHeight - t.clientHeight > 4) {
          var btn = t.nextElementSibling;
          if (btn && btn.hasAttribute('data-more')) btn.hidden = false;
        }
      });
    }
    _toggleMore(btn) {
      var text = btn.previousElementSibling;
      var expanded = text.classList.toggle('is-expanded');
      btn.textContent = expanded ? (btn.getAttribute('data-less-text') || 'Скрий') : (btn.getAttribute('data-more-text') || 'Покажи повече');
    }

    /* ---- Lightbox gallery ---- */
    _openGalleryFrom(photoBtn) {
      var strip = photoBtn.closest('.bh-reviews__photos');
      if (!strip) return;
      this.gallery = (strip.getAttribute('data-photos') || '').split('|||').filter(Boolean);
      this.gIdx = parseInt(photoBtn.getAttribute('data-idx') || '0', 10);
      var multi = this.gallery.length > 1;
      this.lbPrev.hidden = !multi;
      this.lbNext.hidden = !multi;
      this.lbCounter.hidden = !multi;
      if (!this.lb.open) this.lb.showModal();          // top layer → above the drawer dialog
      requestAnimationFrame(() => requestAnimationFrame(() => this.lb.classList.add('is-open')));
      this._render();
    }
    _render() {
      this.lbImg.src = this.gallery[this.gIdx];
      this.lbCounter.textContent = (this.gIdx + 1) + ' / ' + this.gallery.length;
    }
    step(dir) {
      if (!this.gallery || this.gallery.length < 2) return;
      this.gIdx = (this.gIdx + dir + this.gallery.length) % this.gallery.length;
      this._render();
    }
    closeGallery() {
      this.lb.classList.remove('is-open');
      var lb = this.lb;
      setTimeout(function () { if (lb.open) lb.close(); }, 220);
    }
    _bindSwipe() {
      var stage = this.querySelector('[data-lb-stage]');
      var x0 = null;
      stage.addEventListener('touchstart', (e) => { x0 = e.changedTouches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) this.step(dx < 0 ? 1 : -1);
        x0 = null;
      }, { passive: true });
      // click backdrop (not the image) closes
      this.lb.addEventListener('click', (e) => { if (e.target === this.lb) this.closeGallery(); });
    }
  }
  if (!customElements.get('bh-reviews-drawer')) customElements.define('bh-reviews-drawer', BhReviewsDrawer);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-language-flags"] && !Shopify.designMode) return;
  try {
    class BhLangSelect extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.bh-lang__trigger');
      if (!this.trigger) return;
      this.trigger.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); this.toggle(); });
      this._out = (e) => { if (!this.contains(e.target)) this.close(); };
      this._esc = (e) => { if (e.key === 'Escape') { this.close(); this.trigger.focus(); } };
    }
    toggle() { this.hasAttribute('open') ? this.close() : this.open(); }
    open() {
      this.setAttribute('open', '');
      this.trigger.setAttribute('aria-expanded', 'true');
      document.addEventListener('click', this._out);
      document.addEventListener('keydown', this._esc);
    }
    close() {
      this.removeAttribute('open');
      this.trigger.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this._out);
      document.removeEventListener('keydown', this._esc);
    }
  }
  if (!customElements.get('bh-lang-select')) customElements.define('bh-lang-select', BhLangSelect);
  } catch(e) { console.error(e); }
})();

})();
